export const mainImageText = {
  imgUrl: '/images/interview/urbanGate/interview_top.png',
  mobileImgUrl: '/images/interview/urbanGate/interview_top_sp.png',
  imgAlt: 'お別れの場の、そのあとも。みなさまに丁寧にお知らせできます。',
  message: `お別れの場の、そのあとも。
みなさまに丁寧に
お知らせできます。`,
}

export const customerVoiceText = {
  company: 'アーバンゲート',
  companyLocation: '静岡県',
  companyUrl: 'https://kaguyanosato.com/',
  companyImg: '/images/interview/urbanGate/urban-gate.png',
  readText: `株式会社アーバンゲート様は、2021年1月より＠葬儀を導入いただきました。 
導入当初から独自の案内ツールの作成や運用方法の策定などを行い、積極的に＠葬儀をご活用いただいております。 
オンライン葬儀事業の先駆者としてこれまでも多くの喪主様にお使いいただいており、現在ではすべての葬儀で＠葬儀の利用が可能と、トップクラスの＠葬儀実施率となっております。
今回はアーバンゲート代表の中村様に、＠葬儀の導入から喪主様のご意見、また葬儀の実施に留まらない＠葬儀のさらなる活用方法などについてお伺いしました。`,
  infoText: `株式会社アーバンゲート様は、静岡県富士市を拠点とした葬儀社様で、一日一組限定の邸宅型家族葬専用ホール「かぐやの里メモリーホール富士」を運営されております。 「ただお客様のために、そして地域のために。」をモットーに、ご遺族様に寄り添った丁寧で心のこもったサービスは、地域の皆様だけではなく業界からも高く評価されており、静岡県東部の全葬儀社でGoogle口コミ総合1位を獲得した実績もお持ちです。`,
}

export const urbanGateQA = [
  {
    question: '＠葬儀を選定したポイントは？',
    answer: `葬儀社も、これからは様々なオンラインコンテンツの導入が必要不可欠になってくるだろうと考えていました。ただ、単に葬儀のライブ配信が出来る、という事だけではなく、オンラインでの香典決済や、喪主様へのメッセージ送信、などそういった色々なコンテンツを持つサービスを探していました。
そんなときに御社の「アット葬儀」を知りまして、他のサービスと比較し一番内容が充実していたこと、またコストパフォーマンスが良かったことから選定いたしました。
実際に導入してみて、葬儀の際の写真や、故人の写真を見たあとに会葬者がメッセージを送れたりする機能については、喪主様からも喜びの声をいただいております。`,
  },
  {
    question: '＠葬儀をご利用いただくことで、解決できた課題点などはございますでしょうか？',
    answer: `供花供物の受発注を、今までは電話やFAXで行っていましたが、簡単にやり取りできるようになったことは、業務効率の改善として実感しています。 
また、お葬式が終わった後、ご遺族の方に葬儀の様子などをDVDでお渡ししていたのですが、「アット葬儀」ではDVDを用意しなくてもオンライン上で共有することができるので、例えば喪主様がDVDプレーヤーを持っていなくてもスマートフォンやパソコンで閲覧できますし、周りの方にも共有しやすくなった事が挙げられます。 
もう一つは、訃報連絡の紙をプリントアウトする必要が無くなったことは大きいですね。「スマートフォンはお持ちですか？」とたずねて、お持ちであれば「アット葬儀」の訃報案内をお伝えして「これを送ってください。」と案内すればよくなりました。`,
  },
  {
    question: '＠葬儀を実際に利用してみて、実感しているメリットはどのようなところでしょうか？',
    answer: `今までだと突然の訃報で、遠方だったり都合により参列できない、という方には、四十九日の時に参加いただいたり、後日お知らせする、という事がほとんどでした。
それが「アット葬儀」を使う事によって実際の葬儀に参加出来なくてもお葬式の様子だったり、お香典だったり、お花だったり、いち早く確実な情報を伝えることができるようになったことは、とても良いことだと思っています。
やはり言葉だけでは伝わらない事ってあると思うので、よりしっかりとした、丁寧なイメージを発信できるという事は、非常に大きなメリットだと感じています。`,
  },
  {
    question: '＠葬儀を利用してみて、良いと思うポイントを教えてください。',
    answer: `操作がすごく簡単で、手間もかからないので全体的にとても使いやすいですね。
こういったコンテンツを使う事が苦手なスタッフもいるのですが、慣れてくると新しい葬儀の作成も5分～10分で出来てしまいます。
ですので、喪主様からご連絡をいただいた際に、その場で「アット葬儀」の画面を作成し、紙の訃報連絡書よりも早くお客様に提供することが出来ています。
訃報連絡がデジタル化することで、葬儀会場の地図とか、お問い合わせ先などをそのままスマートフォンですぐに見られるのは、とても良いと思います。
また新しい機能や使い勝手が日々進化していくことは、すごく良いと思います。我々葬儀屋さんのユーザー目線で追加されていくのはありがたいですね。`,
  },
  {
    question:
      'より多くの方に＠葬儀をご利用いただくために、御社で取り組んでいる施策があれば教えてください。',
    answer: `WEBのサービスという事で、やはり抵抗を感じるお客様もいらっしゃいます。
そういった場合、喪主様にお使いいただくまで、しっかりと我々がサポートする、というところに力を入れています。
具体的には、我々の方で葬儀などを作成し、それをお客様（喪主様）へお渡しする、という形をとっています。そうすることで、喪主様だけではなく、息子さん、娘さん、お孫さんなどもご遺族でもサービスを使っていただけますので、心理的にもハードルが下がると思います。
また、弊社では「アット葬儀」を基本プランにセットした状態で、お客様には見ていただくようにしています。「アット葬儀を使いませんか？」とお客様に判断をゆだねるのではなく、「うちの葬儀にはアット葬儀がついてますよ」という前提でお渡しすると、最終的には「ああ、やっぱりあってよかったね」と思って貰えています。`,
  },
  {
    question: 'お使い頂いた喪主様から、頂いたお声などございますか？',
    answer: `「アット葬儀」を使うことで、実際の葬儀に来れらなかった人にも報告が出来て良かった、という事をいただいております。
家族葬の場合、お葬式には呼ばないけれど、亡くなったことだけを後からお伝えする、という方は多いんですよね。そんな時にも、家族葬だけど「こんな立派なお葬式をしたんだよ」という事を周りの方に広めることで、喪主様自身も周りの方から「立派な葬儀でよかったね」と言って貰えますし、それによって喪主様の満足度も上がっていくと思います。
ただ訃報をお知らせするだけではなく、丁寧に説明する一つのツールとして、「アット葬儀」というのはすごく充実したツールだと思います。
また、お葬式の時に飾った写真や葬儀の様子、喪主様の挨拶動画なども後から見ることができるので、葬儀が終わって1週間、1か月、2か月と経った時に思い出を振り返ってもらえる機会が提供できることもとても良い事だと思います。`,
  },
  {
    question:
      '実際家族葬を選択される方は様々理由はあると思うのですが、家族以外にはお知らせ自体しない、という喪主様も使ってくれてますよね？どのようにご案内されていますか？',
    answer: `家族葬と言うか、ほぼ密葬に近い、「もう案内すらしない」というケースであっても、お葬式が終わってから葬儀の写真であったりとか、葬儀以外の思い出の写真などを載せる一つの場所として、必ず提供はしています。
そのままお知らせしないのであればそれでも結構ですし、本当に仲の良かった方には納骨の後や四十九日の後などのタイミングでお知らせしたくなる、という事もありますし、そういったときのためにご遺族には必ずご案内するようにしています。
葬儀社は、お葬式のあとのことに関しては、今まではほぼご遺族にお任せしてしまう、というところがあったのですが、葬儀が終わった後に関しても、思い出を残しておいたり、報告するためのツールとしてお使いいただくことで、ご遺族に対しても手厚くフォローすることができます。
それにより、喪主様の満足度も上がると思いますし、そういった意味でも「アット葬儀」はとても良いツールだと思います。`,
  },
  {
    question: '＠葬儀に対するご要望などございましたら、お願いいたします。',
    answer: `葬儀社目線で日々新しい機能や、使いやすい機能が追加されていくことは本当にありがたいので、これらも引き続きお願いしたいと思っています。
また、葬儀社業界としても今後はデジタル化が進んでいくと思いますし、そうなるとより一層現場での対応がいかに早く、丁寧にできるかが求められてくると思います。
そういった意味では、スマートフォンで使えるような、例えばアプリなどでより使いやすく、またスピーディに対応できるようになると良いと思っています。`,
  },
]
